<template>
  <div class="w-24 flex-col items-center justify-center flex gap-1">
    <div class="has-tooltip flex flex-col">
      <button
        class="bg-gray-800 rounded-lg py-2 px-2 text-text-primary text-xs hover:bg-gray-700 duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
        @click="onMatchButtonClick"
        :disabled="!matchIsSuccessfullyAnalyzed && !matchIsRetryable"
      >
        <ArrowPathIcon class="w-4 h-4" v-if="matchIsRetryable" />
        <ArrowRightIcon class="w-4 h-4" v-else />
      </button>
      <div
        class="tooltip rounded shadow-md p-1 bg-gray-700 text-white mt-10 px-2 text-xs ml-[-30px]"
      >
        <span> {{ matchIsRetryable ? $t("matches.row.retry_analysis") : $t("matches.row.go_to_match") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRightIcon, ArrowPathIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  match: {
    type: Object,
    required: true,
  },
  matchIsRetryable: {
    type: Boolean,
    required: true,
  },
  matchIsPermanentlyFailed: {
    type: Boolean,
    required: true,
  },
  matchIsSuccessfullyAnalyzed: {
    type: Boolean,
    required: true,
  },
  matchIsAnalyzing: {
    type: Boolean,
    required: true,
  },
  goToMatchPage: {
    type: Function,
    required: true,
  },
  retryMatch: {
    type: Function,
    required: true,
  },
});

function onMatchButtonClick() {
  if (props.matchIsRetryable) {
    props.retryMatch();
  } else {
    props.goToMatchPage();
  }
}
</script>
